import React from 'react'

const Nodejs_Coding_Pratice_8 = () => {
  return (
    <div>
      <h1>Coding Pratice 8</h1>
    </div>
  )
}

export default Nodejs_Coding_Pratice_8
